export const getSessionNotes = async (api, sessionId, sessionType = "TEAM") => {
  return api.get("/api/v1/session-note/session-details", {
    params: { sessionId, sessionType },
  });
};

export const updateSessionNote = async (api, id, description, isDraft = false) => {
  return api.put(`/api/v1/session-note/${id}`, {
    description,
    isDraft,
  });
};

export const deleteSessionNote = async (api, id) => {
  return api.delete(`/api/v1/session-note/${id}`);
};

export const deleteSessionNoteImage = async (api, noteId, imageId) => {
  return api.delete(`/api/v1/session-note/${noteId}/image/${imageId}`);
};

export const uploadSessionNoteImage = async (api, id, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.upload(`/api/v1/session-note/${id}/upload-image`, form);
};

export const createSessionNote = async (
  api,
  sessionId,
  sessionType,
  description = "",
  isDraft = false,
) => {
  return api.post("/api/v1/session-note", {
    description,
    isDraft,
    sessionId,
    sessionType,
  });
};
